var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1908_15603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1908_15603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81458 14C1.55903 14 1.37014 13.8889 1.24792 13.6667C1.12569 13.4444 1.12569 13.2222 1.24792 13L7.41458 2.33333C7.53681 2.11111 7.73125 2 7.99792 2C8.26458 2 8.45903 2.11111 8.58125 2.33333L14.7479 13C14.8701 13.2222 14.8701 13.4444 14.7479 13.6667C14.6257 13.8889 14.4368 14 14.1813 14H1.81458ZM7.99792 6.66667C7.80903 6.66667 7.65081 6.73044 7.52325 6.858C7.39525 6.986 7.33125 7.14444 7.33125 7.33333V9.33333C7.33125 9.52222 7.39525 9.68044 7.52325 9.808C7.65081 9.936 7.80903 10 7.99792 10C8.18681 10 8.34525 9.936 8.47325 9.808C8.60081 9.68044 8.66458 9.52222 8.66458 9.33333V7.33333C8.66458 7.14444 8.60081 6.986 8.47325 6.858C8.34525 6.73044 8.18681 6.66667 7.99792 6.66667ZM7.99792 12C8.18681 12 8.34525 11.936 8.47325 11.808C8.60081 11.6804 8.66458 11.5222 8.66458 11.3333C8.66458 11.1444 8.60081 10.9862 8.47325 10.8587C8.34525 10.7307 8.18681 10.6667 7.99792 10.6667C7.80903 10.6667 7.65081 10.7307 7.52325 10.8587C7.39525 10.9862 7.33125 11.1444 7.33125 11.3333C7.33125 11.5222 7.39525 11.6804 7.52325 11.808C7.65081 11.936 7.80903 12 7.99792 12ZM2.96458 12.6667H13.0312L7.99792 4L2.96458 12.6667Z",
    fill: "#F35656"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5ad1225e057fbb3c1215f85c572865e3.svg";
export { ForwardRef as ReactComponent };